// extracted by mini-css-extract-plugin
module.exports = {"bubble":"tooltip_bubble__1Nsmg","arrow":"tooltip_arrow__3R_Ey","content":"tooltip_content__Rp46K","iconWrapper":"tooltip_iconWrapper__5XiVo"};